import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { OfflineStorageService } from './offline-storage.service';
import { setLoadingSpinner } from '../store/actions/shared.action';
import { autoLogout } from '../store/actions/auth.actions';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggingOut
  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store<AppState>,
    private offlineStorageService: OfflineStorageService
  ) { }

  login(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/login', JSON.stringify(item), {withCredentials: true});
  }

  register(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/register', JSON.stringify(item), {withCredentials: true});
  }

  forgotPassword(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/forgot-password', JSON.stringify(item), {withCredentials: true});
  }

  resetPassword(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/reset-password', JSON.stringify(item), {withCredentials: true});
  }

  resetPasswordAdmin(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/user/reset-password', JSON.stringify(item), {withCredentials: true});
  }

  logout(): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/user/logout', '', {withCredentials: true});
  }

  userAgreement(item): Observable<any> {    
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/user/agreement', JSON.stringify(item), {withCredentials: true});
  }

  changePassword(item: any): Observable<any> {
    return this.http
    .post<any>(environment.apiUrl + `api/v1/auth/change-password`, JSON.stringify(item),{withCredentials: true});
  }

  
  autoLogout(segment) {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;

    this.logout()
      .toPromise()
      .then((res) => {        
        this.finishLogout(segment);
      })
      .catch((err) => {        
        if (err?.status === 401 && segment !== 'auth') {
          this.router.navigateByUrl('/auth');
        }
        this.finishLogout(segment);
      })
      .finally(() => {        
        this.isLoggingOut = false;    
      });
  }
  private finishLogout(segment: string) {    
    this.router.navigateByUrl('/auth');
    this.offlineStorageService.clear();
    this.store.dispatch(setLoadingSpinner({ status: false }));
    this.store.dispatch(autoLogout());
  }
}
